import styled from 'styled-components'

export const BannerTopPage = styled.a`
  display: block;
  padding: 1rem;
  background: ${({ theme }) => theme.colors.mono.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: 0.8rem;
  margin: 2rem 0;
`

export const BannerTopPageImage = styled.img`
  width: 100%;
  object-fit: contain;
`
